import React, { useEffect } from "react";
// WorldDbSearch wird nicht mehr benötigt
// import WorldDbSearch from './WorldDbSearch';
// import WorldDbStatusFilter from './WorldDbStatusFilter';
import NewWorldDbStatusFilter from './NewWorldDbStatusFilter';
import WorldDbImportFilter from './WorldDbImportFilter';
import NewWorldDbSearch from './NewWorldDbSearch';
import "./WorldDbTableNav.css";

const WorldDbTableNav = ({ 
  statusFilterMode, 
  onStatusFilterChange, 
  importFilterMode,
  onImportFilterChange,
  importOptions,
  setShowUploader,
  displayedCount,
  filteredCount,
  contactedToday,
  isSelectMode,
  toggleSelectMode,
  selectedCount,
  handleDeleteSelected,
  totalDatabaseCount,
  handleOpenAiManager,
  handleOpenAutoSend,
  handleStartMassSpy,
  handleOpenAiCleaner,
  onSearch
}) => {
  // Debug-Log zur Überprüfung der onSearch-Prop
  useEffect(() => {
    // console.log("WorldDbTableNav: onSearch-Prop erhalten:", !!onSearch);
  }, []);
  
  return (
    <div className="world-db-header-container">
      <h2 className={`world-db-title ${isSelectMode ? 'hidden' : ''}`}>
        {filteredCount !== null
          ? `${displayedCount} of ${filteredCount} contacts`
          : `${displayedCount} of ${totalDatabaseCount || 0} contacts loaded`
        }
        <span className="contacted-today">({contactedToday} Contacted Today)</span>
      </h2>
      <div className="world-db-controls">
      <button 
          className={`world-db-select-btn ${isSelectMode ? 'active' : ''}`}
          onClick={toggleSelectMode}
        >
          <svg 
            width="16" 
            height="16" 
            viewBox="0 0 24 24" 
            fill="none"
          >
            <path 
              d="M9 11l3 3L22 4M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" 
              stroke="currentColor" 
              strokeWidth="2" 
              strokeLinecap="round" 
              strokeLinejoin="round"
            />
          </svg>
          {isSelectMode ? `Cancel (${selectedCount})` : ''}
        </button>
                {/* Zeige Delete-Button nur an, wenn Einträge ausgewählt sind */}
                {isSelectMode && selectedCount > 0 && (
          <button 
            className="world-db-delete-btn"
            onClick={handleDeleteSelected}
          >
            <img src="/img/delete.svg" style={{width: '16px', height: '16px', filter: 'invert(21%) sepia(100%) saturate(7414%) hue-rotate(359deg) brightness(94%) contrast(118%)'}} alt="Delete" />
            ({selectedCount})
          </button>
        )}


        {/* AI Cleaner Button - wird nur angezeigt, wenn Einträge ausgewählt sind */}
        {isSelectMode && selectedCount > 0 && (
          <button 
            className="world-db-ai-cleaner-btn"
            onClick={handleOpenAiCleaner}
            style={{
              background: 'linear-gradient(-45deg, #ee7752, #e73c7e, #23a6d5, #23d5ab)',
              backgroundSize: '400% 400%',
              animation: 'gradient 3s ease infinite',
              border: 'none',
              color: 'white',
              fontWeight: 'bold',
              textShadow: '0 1px 2px rgba(0,0,0,0.2)',
              boxShadow: '0 2px 10px rgba(0,0,0,0.1), inset 0 0 5px rgba(255,255,255,0.4)',
              transition: 'all 0.3s ease'
            }}
          >
           <img src="/img/wand.svg" style={{
             width: '16px', 
             height: '16px', 
             filter: 'brightness(0) invert(1)',
             animation: 'glow 1.5s ease-in-out infinite alternate'
           }} alt="Magic Cleaner" />
           Cleaner ({selectedCount})
          </button>
        )}

        {/* Mass Spy Button - wird nur angezeigt, wenn Einträge ausgewählt sind */}
        {isSelectMode && selectedCount > 0 && (
          <button 
            className="world-db-mass-spy-btn"
            onClick={handleStartMassSpy}
          >
           <img 
             src="/img/aug.svg" 
             style={{
               width: '16px', 
               height: '16px', 
               filter: 'brightness(0) invert(1)',
               animation: 'mysticalPulse 2s infinite ease-in-out'
             }} 
             alt="Spy" 
           />
            Spy ({selectedCount})
          </button>
        )}
        
        {/* AI Manager Button - wird nur angezeigt, wenn Einträge ausgewählt sind */}
        {isSelectMode && selectedCount > 0 && (
          <button 
            className="world-db-ai-manager-btn"
            onClick={handleOpenAiManager}
          >
            <img 
              src="/img/email.svg" 
              style={{
                width: '16px', 
                height: '16px', 
                filter: 'brightness(0) invert(1)', 
                transition: 'all 0.3s ease'
              }} 
              alt="Multi" 
            />
            Multi ({selectedCount})
          </button>
        )}


        {/* AutoSend Button - wird nur angezeigt, wenn Einträge ausgewählt sind */}
        {isSelectMode && selectedCount > 0 && (
          <button 
            className="world-db-auto-send-btn"
            onClick={handleOpenAutoSend}
            title="AutoSend with optional cleaning"
          >
           <img 
             src="/img/paperplane.svg" 
             style={{
               width: '14px', 
               height: '14px', 
               filter: 'brightness(0) invert(1)',
               transition: 'all 0.3s ease'
             }} 
             alt="AutoSend" 
           />
            AI Send+ ({selectedCount})
          </button>
        )}

        {/* WorldDbSearch Komponente wurde entfernt und durch die neue ersetzt */}
        <NewWorldDbSearch onSearch={onSearch} />
        
        {/* Neuer Import-Filter */}
        <WorldDbImportFilter 
          currentImportFilter={importFilterMode}
          onImportFilterChange={onImportFilterChange}
          isLoading={false}
          importOptions={importOptions}
        />
        
        {/* Status-Filter */}
        <NewWorldDbStatusFilter 
          currentStatusFilter={statusFilterMode}
          onFilterChange={onStatusFilterChange}
          isLoading={false}
        />
        
        <button 
          className="world-db-import-btn"
          onClick={() => setShowUploader(true)}
        >
          Import
          <img src="/img/csv.svg" alt="Import" />
        </button>
      </div>
    </div>
  );
};

export default WorldDbTableNav; 